<template>
    <ResultsNetworkBanner bannerType="success" header="In network.">
        {{message}} <span>Check your <a href="/my/plan-overview/coverage.html" :data-card-rank="rank">coverage details</a> to learn more.</span>  
    </ResultsNetworkBanner>
</template>

<script setup>

    const { context } = useFCPModel()

    const routineCare = [
        'Optometry (Routine care)',
        'Pediatric Optometry',
        'Ophthalmology',
        'Pediatric Ophthalmology'
    ]

    const nonRoutineCare = [
        'Optometry (Non-routine care)',
        'Ophthalmology (Non-routine care)'
    ]

    const message = computed(() => {
        if ( routineCare.includes(context.value.term) ) return "This is routine care only."
        if ( nonRoutineCare.includes(context.value.term) ) return "This is non-routine care only."
    })

</script>